/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import Gift from './gift_lottie.json';

export default function GiftLottie(props) {
  const container = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: Gift,
    });
  }, []);

  return (
    <div className={props.className} ref={container} />
  );
}
